'use client'

import { formatPrice } from '@/core/lib/utils/format-price'
import { useAuth } from '@/core/store/auth'
import { AccountType } from '@/core/types/enums/account-type.enum'
import { useReservationStore } from '@/features/reservation/store'
import { useTranslations } from 'next-intl'

export const PaymentText = () => {
  const t = useTranslations()
  const { paymentDetails, createdTrip } = useReservationStore()
  const currency = createdTrip?.currency
  const { user } = useAuth()
  const accountType = user?.accountType

  const generatePaymentText = (
    amountFromWallet?: number,
    amountFromBank?: number,
    amountFromPaypal?: number,
  ) => {
    const messageParts: string[] = []

    if (amountFromWallet) {
      messageParts.push(
        `${t('trip.willPay')} ${formatPrice(amountFromWallet, currency)} ${accountType === AccountType.PROVIDER ? `${t('trip.fromWalletAndCredit')}` : `${t('trip.fromWallet')}`} `,
      )
    }

    if (amountFromBank) {
      if (messageParts.length > 0) {
        messageParts.push(
          ` ${t('conjunctions.and')}  ${formatPrice(amountFromBank, currency)} ${t('trip.fromBank')} `,
        )
      } else {
        messageParts.push(
          ` ${t('trip.willPay')}  ${formatPrice(amountFromBank, currency)} ${t('trip.fromBank')}`,
        )
      }
    }
    if (amountFromPaypal) {
      if (messageParts.length > 0) {
        messageParts.push(
          ` ${t('conjunctions.and')}  ${formatPrice(amountFromPaypal, currency)} ${t('trip.fromPaypal')} `,
        )
      } else {
        messageParts.push(
          ` ${t('trip.willPay')}  ${formatPrice(amountFromPaypal, currency)} ${t('trip.fromPaypal')}`,
        )
      }
    }

    if (messageParts.length === 0) {
      return `${t('trip.noPayment')}`
    }

    return messageParts.join(' ')
  }

  if (!paymentDetails) {
    return null
  }
  return (
    <p className='bg-pale-blue bg-opacity-25 w-fit rounded-xl px-5 py-3'>
      {generatePaymentText(
        paymentDetails.amountFromWallet,
        paymentDetails.amountFromBank,
        paymentDetails.amountFromPaypal,
      )}
    </p>
  )
}
